import StickyPageHeader from '../components/common/StickyPageHeader';
import DefaultModeList from '../components/lists/DefaultModeList';
import { useDefaultModes } from '../hooks/apiHooks';
import Layout from '../layout';

const AdminModesPage = ({ disableLayout, routes }) => {
  const { defaultModes } = useDefaultModes();

  const content = (
    <>
      <StickyPageHeader isAdmin title="Settings / Modes of Transport" />
      <DefaultModeList id="modes" modes={defaultModes} />
    </>
  );

  if (disableLayout) return content;

  return (
    <Layout
      showCarriersNavigation
      disableLoading={false}
      menuIndex={0}
      routes={routes}
    >
      {content}
    </Layout>
  );
};

export default AdminModesPage;
